import script from "./FileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FileInput.vue?vue&type=script&setup=true&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=6df3d715&lang=less&scoped=true"

import exportComponent from "M:\\Meshkat\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df3d715"]])

export default __exports__